function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "add_shopping_cart-black-18dp"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M18,18H0V0H18V18Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  d: "M13.5,16A1.5,1.5,0,1,1,15,14.5,1.5,1.5,0,0,1,13.5,16Zm-8,0A1.5,1.5,0,1,1,7,14.5,1.5,1.5,0,0,1,5.5,16Zm8.789-4H4.762a1.532,1.532,0,0,1-1.588-1.466,1.343,1.343,0,0,1,.2-.7l1.071-1.8L1.588,2.467H0V1H2.6l.746,1.467L4.1,3.933,5.873,7.4l.1.2h5.572l2.191-3.667.873-1.466h.007l1.381.7L12.937,8.311a1.607,1.607,0,0,1-1.389.755H5.635l-.715,1.2L4.9,10.35a.176.176,0,0,0,.059.129.2.2,0,0,0,.139.055h9.191V12ZM9.75,6H8.25V3.75H6V2.25H8.25V0h1.5V2.25H12v1.5H9.75V6Z",
  transform: "translate(0 1)"
}));

var SvgIconCart = function SvgIconCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Cart_QTY",
    "data-name": "Icon Cart/QTY",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#878787",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-cart.224b0f01.svg";
export { ForwardRef as ReactComponent };